import PropTypes from 'prop-types'
import React from 'react'

import { withI18n } from '@thebeansgroup/i18n'
import TextLink from '@thebeansgroup/ui_ctas/text_link_new'

import Layout from '@components/layout'
import SingleSignOn from '@components/sso'

import AvatarIllustration from '../../../../../../../images/avatar_illustration.svg'

import { getDescription } from './helpers'
import * as styles from './styles'

export class WrongPasswordScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  renderImage() {
    return <AvatarIllustration css={styles.image} />
  }

  renderEmail() {
    return <div css={styles.email}>{this.props.email}</div>
  }

  renderLinks() {
    return (
      <div css={styles.links}>
        {this.renderBackToLoginLink()}
        {this.renderLinkSeparator()}
        {this.renderForgottonPasswordLink()}
      </div>
    )
  }

  renderLinkSeparator() {
    return <span css={styles.linkSeparator}>•</span>
  }

  renderBackToLoginLink() {
    const { t, backToLoginClickHandler } = this.props
    return (
      <TextLink
        underlined
        colour='violet'
        text={t('a_back_to_log_in')}
        onClick={backToLoginClickHandler}
      />
    )
  }

  renderForgottonPasswordLink() {
    const { t, resetPasswordClickHandler } = this.props
    return (
      <TextLink
        underlined
        colour='violet'
        text={t('a_reset_password')}
        onClick={resetPasswordClickHandler}
      />
    )
  }

  renderSSO() {
    const {
      t,
      token,
      userProviders,
      logInHandler,
      requestErrorHandler,
      ssoNotFoundHandler
    } = this.props
    return (
      <SingleSignOn
        type='logIn'
        circularButtons={false}
        google={userProviders.indexOf('Google') > -1}
        facebook={userProviders.indexOf('Facebook') > -1}
        googleLabel={t('a_log_in_google')}
        facebookLabel={t('a_log_in_facebook')}
        token={token}
        requestSuccessHandler={logInHandler}
        requestErrorHandler={requestErrorHandler}
        ssoNotFoundHandler={ssoNotFoundHandler}
      />
    )
  }

  renderContent() {
    return (
      <>
        {this.renderImage()}
        {this.renderEmail()}
        {this.renderSSO()}
        {this.renderLinks()}
      </>
    )
  }

  render() {
    return (
      <Layout
        title={this.props.t('d_wrong_password')}
        description={getDescription(this.props)}
      >
        {this.renderContent()}
      </Layout>
    )
  }
}

WrongPasswordScreen.propTypes = {
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  userProviders: PropTypes.array.isRequired,
  logInHandler: PropTypes.func.isRequired,
  requestErrorHandler: PropTypes.func.isRequired,
  resetPasswordClickHandler: PropTypes.func.isRequired,
  backToLoginClickHandler: PropTypes.func.isRequired,
  ssoNotFoundHandler: PropTypes.func.isRequired
}

export default withI18n(WrongPasswordScreen)
